import { LoanType } from '../enums/loan-type.enum';

export const LoanTypeLabel = {
  [LoanType.NEW_LOAN]: 'Novo empréstimo',
  [LoanType.NEW_LOAN_PORTABILITY]: 'Portabilidade',
  [LoanType.LOAN_REFINANCE_PORTABILITY]: 'Refin Portabilidade',
  [LoanType.LOAN_REFINANCE]: 'Refinanciamento',
};
